import type { PropsWithChildren } from 'react';

export const AuthLayout = ({ children }: PropsWithChildren): React.ReactElement => (
  <main className="auth-layout">{children}</main>
);
